enum FixedColumnDirection {
    left = "left",
    right = "right",
}

export {
    FixedColumnDirection
}